<div class="icon-m icon-left{{#if item.owner}} ui-icon-star{{/if}} customer-item" {{#if item.owner}}title="Vessel customer"{{/if}}>
  <h3>{{item.company}}</h3>
</div>
